/* eslint-disable no-console */

/* eslint-disable complexity */
import { AxiosResponse } from 'axios';
import isNil from 'lodash/isNil';
import isString from 'lodash/isString';

import { AttachmentFile } from './Attachment';
import { JiraAttachment } from './JiraAttachment';
import { TestStepDTO } from './TestStepDTO';

type TestStepGenericPatchModel = {
  fields: {
    step?: string;
    result?: string;
    data?: string;
    attachments?: string;
  };
};

export default class TestStep {
  id: number;
  step: string;
  result: string;
  data: string;
  attachments: Array<JiraAttachment>;
  attachmentsTemp?: Array<AttachmentFile>;
  executionAttachments: Array<JiraAttachment>;
  isNew: boolean;
  testCaseId: number;
  isStatusUpdate: boolean;
  stepSaveFailed: boolean;
  origin?: Promise<AxiosResponse> | AxiosResponse | Record<string, never>;

  constructor(
    testCaseId = 0,
    step = '',
    result = '',
    data = '',
    attachments: Array<JiraAttachment> = []
  ) {
    this.id = -1 * new Date().getTime();
    this.step = step;
    this.result = result;
    this.data = data;
    this.attachments = attachments;
    this.isNew = true;
    this.testCaseId = testCaseId;
    this.isStatusUpdate = false;
    this.executionAttachments = [];
    this.stepSaveFailed = false;
  }

  static from(json: TestStepDTO): TestStep {
    const testStep = Object.assign(new TestStep(), json);
    testStep.stepSaveFailed = false;

    if (isNil(json.isNew)) {
      testStep.isNew = false;
    }

    if (isString(testStep.attachments)) {
      testStep.attachments = JSON.parse(json.attachments);
    } else if (isNil(testStep.attachments)) {
      testStep.attachments = JSON.parse('[]');
    }

    if (isString(testStep.executionAttachments)) {
      testStep.executionAttachments = JSON.parse(json.executionAttachments);
    }
    return testStep;
  }

  static getCreateRequestData(json: TestStep): TestStep {
    const testStep = Object.assign(new TestStep(), json);
    return getRequestData(testStep);
  }

  static async getUpdateRequestData(
    json: TestStepDTO | TestStep
  ): Promise<TestStepGenericPatchModel> {
    const testStep = Object.assign(new TestStep(), json);
    if (json.id < 0 && !isNil(json.origin)) {
      testStep.id = (await json.origin).data.id;
    }

    const attachments = JSON.stringify(
      testStep.attachments.map((attachment) => ({
        id: attachment.id,
      }))
    );

    return {
      fields: {
        step: testStep.step || '',
        result: testStep.result || '',
        data: testStep.data || '',
        ...(attachments.length > 0 ? { attachments: attachments } : {}),
      },
    };
  }

  static async getId(testStep: TestStep): Promise<number> {
    if (testStep.id < 0 && !isNil(testStep.origin)) {
      testStep.id = (await testStep.origin).data.id;
    }
    return testStep.id;
  }
}

function getRequestData(testStep) {
  const {
    isNew: _isNew,
    origin: _origin,
    attachmentsTemp,
    isStatusUpdate,
    stepSaveFailed,
    attachments,
    executionAttachments,
    ...data
  } = testStep;
  const attachmentShortList = attachments.map((attachment) => ({
    id: attachment.id,
  }));
  data.attachments = JSON.stringify(attachmentShortList);
  return data;
}
